module.exports = __webpack_public_path__ + "media/dotspix.03cdf340.mp4";